import React, { FC } from "react";
import { TableBody, TableCell } from "@mui/material";
import { ProjectResponse } from "@api/projects/mutations";
import { EmptyRow, RenderRow } from "@components/create-project/table/helpers";
import { useTranslation } from "react-i18next";

interface PriceInformationTableProps {
  offer: ProjectResponse;
}

export const PriceInformationTable: FC<PriceInformationTableProps> = ({offer}) => {
  const {t} = useTranslation();

  return (
    <TableBody>
      <tr>
        <TableCell className="w-full bg-black" sx={{p: "1px 4px", color: "white"}} colSpan={5}>
          {t("project.table.priceInformation.title")}
        </TableCell>
      </tr>

      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.gp")}
        name="GP (W+WW)"
        caseType="FO"
        units="EUR/a"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.ap")}
        name="AP (W+WW)"
        caseType="FO"
        units="EUR/a"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.pgTemp")}
        name="GP (TEMP)"
        caseType="FO"
        units="EUR/a"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.mp")}
        name="MP"
        caseType="FO"
        units="EUR/a"
        underline
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.summePa")}
        name="Summe p.a."
        caseType="FO"
        units="EUR/a"
        fontWeight={700}
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.totalPrice")}
        name="Total Price rel."
        caseType="FO"
        units=" "
        fontStyle="italic"
      />

      <EmptyRow/>

      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.gp")}
        name="GP (W+WW) per month"
        caseType="FO"
        units="EUR/mo"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.ap")}
        name="AP (W+WW) per month"
        caseType="FO"
        units="EUR/mo"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.pgTemp")}
        name="GP (TEMP) per month"
        caseType="FO"
        units="EUR/mo"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.mp")}
        name="MP per month"
        caseType="FO"
        units="EUR/mo"
        underline
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.summePa")}
        name="Summe p.m."
        caseType="FO"
        units="EUR/mo"
        fontWeight={700}
      />

      <EmptyRow/>

      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.bkz")}
        name="BKZ"
        caseType="FO"
        units="EUR"
        fontWeight={700}
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.bkzRel")}
        name="BKZ rel."
        caseType="FO"
        units=" "
      />

      <EmptyRow/>

      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.gp")}
        name="GP (W+WW) per m2"
        caseType="FO"
        units="EUR/m2*a"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.ap")}
        name="AP (W+WW) per m2"
        caseType="FO"
        units="EUR/m2*a"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.pgTemp")}
        name="GP (TEMP) per m2"
        caseType="FO"
        units="EUR/m2*a"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.mp")}
        name="MP per m2"
        caseType="FO"
        units="EUR/m2*a"
        underline
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.summePaPerM2")}
        name="Summe p.a. per m2"
        caseType="FO"
        units="EUR/m2*a"
        fontWeight={700}
      />

      <EmptyRow/>

      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.gp")}
        name="GP (W+WW) per m2 per month"
        caseType="FO"
        units="EUR/m2*a"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.ap")}
        name="AP (W+WW) per m2 per month"
        caseType="FO"
        units="EUR/m2*a"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.pgTemp")}
        name="GP (TEMP) per m2 per month"
        caseType="FO"
        units="EUR/m2*a"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.mp")}
        name="MP per m2 per month"
        caseType="FO"
        units="EUR/m2*a"
        underline
      />
      <RenderRow
        offer={offer}
        label={t("project.table.priceInformation.summePmPerM2")}
        name="Summe p.m. per m2"
        caseType="FO"
        units="EUR/m2*a"
        fontWeight={700}
      />

        <EmptyRow />

        <RenderRow
          offer={offer}
          label={t("project.table.priceInformation.ap")}
          name="AP (W+WW) per MWh"
          caseType="FO"
          units="EUR/MWh"
        />
    </TableBody>
  );
};
